import { useEffect, useState } from "react";
import { useLaunchPromo } from "@/lib/use-launch-promo";
import { Gift } from "lucide-react";
import { cn } from "@/lib/utils";

export function LaunchCounter({
  variant = "pill",
  className,
}: {
  variant?: "pill" | "block";
  className?: string;
}) {
  // Evita hydration mismatch: il dato della promo arriva solo client-side,
  // quindi non renderizziamo nulla durante l'SSR.
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  const { data } = useLaunchPromo();
  if (!mounted || !data || !data.active || data.remaining <= 0) return null;

  if (variant === "block") {
    const pct = Math.min(100, Math.round((data.taken / data.max_chefs) * 100));
    return (
      <div className={cn("rounded-xl border border-gold/40 bg-gold-muted/30 p-5", className)}>
        <div className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-gold-foreground">
          <Gift className="h-4 w-4 text-gold" /> Offerta di lancio
        </div>
        <div className="mt-2 font-display text-3xl">
          {data.remaining} <span className="text-base font-normal text-muted-foreground">/ {data.max_chefs} posti ancora disponibili</span>
        </div>
        <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-background">
          <div className="h-full rounded-full bg-gold transition-all" style={{ width: `${pct}%` }} />
        </div>
        <p className="mt-3 text-sm text-muted-foreground">
          I primi {data.max_chefs} chef ricevono {data.duration_days} giorni di Premium gratis + badge Founder permanente. Nessuna carta richiesta.
        </p>
      </div>
    );
  }

  return (
    <span className={cn("inline-flex items-center gap-2 rounded-full border border-gold/50 bg-gold-muted/40 px-3 py-1 text-xs font-medium", className)}>
      <Gift className="h-3.5 w-3.5 text-gold" />
      🎁 {data.remaining}/{data.max_chefs} posti Premium gratuiti
    </span>
  );
}